var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"title"},[_vm._v("404")]),_c('p',{staticClass:"subtitle"},[_vm._v("页面未找到")]),_c('p',{staticClass:"message"},[_vm._v("您访问的页面不存在")]),_c('router-link',{staticClass:"back-home",attrs:{"to":"/"}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }